export default __webpack_public_path__ + "static/media/lobby-text-hover.220e2a25.png";